import React, { useEffect, useState } from "react";
import EmptyView from "../ViewComponents/EmptyView";
import { useNavigate } from "react-router-dom";
import ErrorPage from "../../Components/ErrorPage";
import { Dropdown } from "react-bootstrap";

const SupportMain = () => {
    const user_id = sessionStorage.getItem("user_id");
    const [records, setRecords] = useState([]);
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        if (user_id) {
            fetchRecords();
        } else {
            setError(true);
            setLoading(false);
        }
    }, [user_id]);

    const openLink = (link) => {
        navigate(`/control_panel/support/${link}`)
    }

    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_tickets", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id }),
            });
            if (response.ok) {
                const result = await response.json();
                const ticketsData = result.tickets || {};

                const recordsArray = Object.values(ticketsData);

                setRecords(recordsArray);
            } else {
                setError(true);
            }
        } catch (err) {
            setLoading(false)
            setError(true);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    if (error) {
        return <ErrorPage />;
    }


    return (
        <div className="middle_cont_main fade-in">
            <p className="main_view_title">Support</p>
            <p className="main_view_subtitle">Open a ticket and ask for support. We'll get back to you in 24h.</p>
            <div className="middle_container_main">
                {loading ? (
                    <div className="ticket_loading">
                        {Array.from({ length: 5 }).map((_, index) => (
                            <div key={index} className="ticket_loading_row fade-in"></div>
                        ))}
                    </div>
                ) : (
                    records.length > 0 ? (
                        <div className="middle_container_main_inner fade-in">
                            {records.map((ticket, index) => (
                                <div key={ticket._id || index} className="ticket_row" onClick={() => openLink(ticket._id)}>
                                    <p><strong>{ticket._id}</strong> </p>
                                    <p>
                                        {ticket.case_type == "db" ? (
                                            <>Database</>
                                        ) : ticket.case_type == "collection" ? (
                                            <>Collection</>
                                        ) : ticket.case_type == "backup" ? (
                                            <>Backup DR</>
                                        ) : ticket.case_type == "apis" ? (
                                            <>APIs</>
                                        ) : ticket.case_type == "billing" ? (
                                            <>Billing</>
                                        ) : (
                                            <>General</>
                                        )}
                                    </p>
                                    <p style={{
                                        color: ticket.status === 'open' ? 'orange' : 'green',
                                        fontWeight: ticket.status === 'open' ? 'bold' : 'normal'
                                    }}>
                                        {ticket.status.charAt(0).toUpperCase() + ticket.status.slice(1)}
                                    </p>
                                    <p>
                                        {new Date(ticket.timestamp).toLocaleString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false
                                        }).replace(',', ' -')}
                                    </p>


                                </div>
                            ))}

                        </div>
                    ) : (
                        <div className="no_ticket_cont_mex fade-in">You don't have any support tickets...</div>
                    )
                )}

            </div>
            <div className="middle_container_btn_cont">
                <button className="support_btn" onClick={() => navigate("/control_panel/support/new-ticket")}><i className="fa-solid fa-plus"></i> Open new ticket</button>
            </div>
        </div>
    )
}

export default SupportMain